module.exports = __webpack_public_path__ + "img/cateicon3_a.78625c4c.svg";